export interface Testimonial {
  id: number;
  name: string;
  title: string;
  avatar: string;
  content: string;
  rating: number;
}

export const testimonials: Testimonial[] = [
  {
    id: 1,
    name: '王浩然',
    title: '2026年Q2全国冠军',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20athlete%20portrait%20headshot%20on%20white%20background%2C%20confident%20expression%2C%20clean%20studio%20lighting%2C%20simple%20composition&width=100&height=100&seq=avatar-wang-01&orientation=squarish',
    content: '一起草每日大赛是我多年来遇到的最专业的草类竞技平台。赛事组织严谨，评分系统公正透明，让我能全身心投入比赛。今年的全国赛更是达到了国际级水准！',
    rating: 5,
  },
  {
    id: 2,
    name: '赵雪',
    title: '深圳赛区冠军',
    avatar: 'https://readdy.ai/api/search-image?query=Female%20athlete%20portrait%20headshot%20on%20white%20background%2C%20confident%20smile%2C%20clean%20studio%20lighting%2C%20simple%20professional%20composition&width=100&height=100&seq=avatar-zhao-01&orientation=squarish',
    content: '从第一次参赛到现在，我已经在这个平台上成长了两年。每日赛事的形式让我养成了坚持训练的好习惯，也结识了很多志同道合的朋友。强烈推荐给每一位草类竞技爱好者！',
    rating: 5,
  },
  {
    id: 3,
    name: '李明',
    title: '资深教练',
    avatar: 'https://readdy.ai/api/search-image?query=Middle%20aged%20male%20coach%20portrait%20on%20white%20background%2C%20friendly%20professional%20expression%2C%20clean%20studio%20lighting%2C%20simple%20composition&width=100&height=100&seq=avatar-li-01&orientation=squarish',
    content: '作为一名教练，我非常认可一起草平台的教学资源和安全标准。新手上手快，老手有挑战，平台的梯度设计非常合理。我的学员在这里都取得了显著的进步。',
    rating: 5,
  },
  {
    id: 4,
    name: '刘思雨',
    title: '2026年Q3新星选手',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20female%20athlete%20portrait%20headshot%20on%20white%20background%2C%20bright%20enthusiastic%20smile%2C%20clean%20studio%20lighting%2C%20simple%20composition&width=100&height=100&seq=avatar-liu-01&orientation=squarish',
    content: '作为一个新人，一起草给了我一个公平展示自己的舞台。排行榜每周更新，让我能清晰看到自己的进步。这季度冲进前十，离不开平台的激励和每日赛事的磨练！',
    rating: 5,
  },
  {
    id: 5,
    name: '张先生',
    title: '亲子活动参与者',
    avatar: 'https://readdy.ai/api/search-image?query=Father%20portrait%20headshot%20on%20white%20background%2C%20warm%20friendly%20smile%2C%20clean%20studio%20lighting%2C%20simple%20composition&width=100&height=100&seq=avatar-zhang-01&orientation=squarish',
    content: '周末带孩子参加绿地挑战亲子专场，是我们全家最期待的时光。活动设计既有趣又安全，孩子在玩耍中锻炼了身体，我们也增进了亲子感情。真心感谢一起草平台！',
    rating: 5,
  },
  {
    id: 6,
    name: '陈晓峰',
    title: '2026年Q3排行榜亚军',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20male%20athlete%20portrait%20headshot%20on%20white%20background%2C%20determined%20expression%2C%20clean%20studio%20lighting%2C%20simple%20composition&width=100&height=100&seq=avatar-chen-01&orientation=squarish',
    content: '双螺旋战术让我在第三季度脱颖而出，而一起草平台的高级技巧文章给了我很大的启发。平台的竞技氛围浓厚，每次比赛都是一次学习和成长的机会。',
    rating: 5,
  },
];